import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function AdminUsersWebPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API}/coins/admin/users`);
      const data = await res.json();

      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      alert("Impossible de charger les utilisateurs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleAction = async (email, action) => {
    const ok = window.confirm(
      `Confirmer l'action "${action}" pour ${email} ?`
    );

    if (!ok) return;

    try {
      await fetch(`${API}/coins/admin/users/action`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          action
        })
      });

      alert("Action effectuée");
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert("Action impossible");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020b14",
        padding: 18,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <h1
          style={{
            color: "#00f2ff",
            fontSize: 22,
            fontWeight: "bold",
            marginBottom: 18,
            textAlign: "center"
          }}
        >
          👥 UTILISATEURS
        </h1>

        {loading ? (
          <div
            style={{
              color: "#00f2ff",
              textAlign: "center",
              marginTop: 40
            }}
          >
            Chargement...
          </div>
        ) : users.length === 0 ? (
          <div
            style={{
              color: "#8fa6ad",
              textAlign: "center",
              marginTop: 40
            }}
          >
            Aucun utilisateur.
          </div>
        ) : (
          users.map((item) => (
            <div
              key={item.email}
              style={{
                background: "#051626",
                padding: 16,
                borderRadius: 10,
                marginBottom: 14,
                border: "1px solid #1a2b3c"
              }}
            >
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  marginBottom: 6
                }}
              >
                👤 {item.pseudo || "Utilisateur"}
              </div>

              <div style={textStyle}>📧 {item.email}</div>
              <div style={textStyle}>🎬 Vidéos : {item.video_count || 0}</div>
              <div style={textStyle}>💰 Coins : {item.coins || 0}</div>
              <div style={textStyle}>📌 Statut : {item.status || "actif"}</div>

              <div
                style={{
                  display: "flex",
                  gap: 8,
                  marginTop: 12,
                  flexWrap: "wrap"
                }}
              >
                <button
                  style={{ ...btnStyle, background: "#ffaa00" }}
                  onClick={() => handleAction(item.email, "ban")}
                >
                  Ban
                </button>

                <button
                  style={{ ...btnStyle, background: "#00c853" }}
                  onClick={() => handleAction(item.email, "unban")}
                >
                  Unban
                </button>

                <button
                  style={{ ...btnStyle, background: "#ff0033" }}
                  onClick={() => handleAction(item.email, "delete")}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "#007bff",
            padding: 12,
            borderRadius: 8,
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            marginTop: 10,
            cursor: "pointer"
          }}
        >
          ← Retour Admin
        </button>
      </div>
    </div>
  );
}

const textStyle = {
  color: "#8fa6ad",
  fontSize: 13,
  marginTop: 4
};

const btnStyle = {
  flex: 1,
  minWidth: 110,
  padding: 10,
  borderRadius: 6,
  border: "none",
  color: "#fff",
  fontSize: 12,
  fontWeight: "bold",
  cursor: "pointer"
};

export default AdminUsersWebPage;
